import { createAction, props } from '@ngrx/store';

import { FeelSubscriptionCommands } from '../../domain/commands/feel-subscription.commands';
import { FeelSubscriptionEvents } from '../../domain/events/feel-subscription.events';

export const FeelSubscriptionJoin = createAction(
    FeelSubscriptionCommands.FEEL_SUBSCRIPTION_JOIN,
    props<{ newsletterSections?: string[] }>()
);
export const FeelSubscriptionJoinSuccess = createAction(
    FeelSubscriptionEvents.FEEL_SUBSCRIPTION_JOIN_SUCCESS,
    props<{ newsletter: boolean }>()
);
export const FeelSubscriptionJoinNeedsLogin = createAction(
    FeelSubscriptionEvents.FEEL_SUBSCRIPTION_JOIN_NEEDS_LOGIN,
    props<{ newsletterSections?: string[] }>()
);
export const FeelSubscriptionJoinError = createAction(
    FeelSubscriptionEvents.FEEL_SUBSCRIPTION_JOIN_ERROR,
    props<Error>()
);
